import Immutable from 'immutable';

const initialPageState = Immutable.Map({
    loading: true,
    hasErrors: false,
    chatEnabled: true,
    errorMessage: '',
    lastMessageHasError: false
});

const pageState = (state = initialPageState, action) => {
    switch (action.type) {
        case 'SET_CLIENT':
            // Only set loading to false if not waiting for socket
            return state.merge({
                loading: action.response.client.chat,
                chatEnabled: action.response.client.chat,
                hasErrors: false,
                errorMessage: ''
            });
        case 'SET_SOCKET_CONNECTED':
            return state.merge({
                loading: false
            });
        case 'SET_PAGE_ERROR':
            let errorMessage;

            if (action.error.response.status === 402) {
                errorMessage = "This chat is in trial mode and can only be accessed by a team member.";
            } else if (action.error.response.status === 503) {
                errorMessage = "Our services are temporarily unavailable. \n Stay on this page and we will automatically re-direct you when things are back up."
            } else {
                errorMessage = "An error occurred."
            }

			return state.merge({
				loading: false,
				hasErrors: true,
                errorMessage: errorMessage
			});
        case 'LAST_MESSAGE_ERROR':
            return state.set('lastMessageHasError', action.error)
        default:
            return state;
    }
}

export default pageState;


// WEBPACK FOOTER //
// ./src/reducers/page-state.js